import { useState } from 'react';
import { Box, Typography, styled } from '@mui/material';
import { CloseFullscreen } from '@mui/icons-material';

import CodeMirror from '@uiw/react-codemirror';
import { html } from '@codemirror/lang-html';
import { javascript } from '@codemirror/lang-javascript';
import { css } from '@codemirror/lang-css';
import { oneDark } from '@codemirror/theme-one-dark';

const Container = styled(Box)`
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    flex-direction: column;
    padding: 0 8px 8px;
`;

const Header = styled(Box)`
    display: flex;
    justify-content: space-between;
    background: #060606;
    color: #AAAEBC;
    font-weight: 700;
`;

const Heading = styled(Box)`
    background: #1d1e22;
    padding: 9px 12px;
    display: flex;
`;

const Editor = ({ heading, language, value, onChange, icon, color }) => {
    const [open, setOpen] = useState(true);

    // Select language extension based on prop
    const getLanguageExtension = (lang) => {
        switch (lang) {
            case 'html': return html();
            case 'css': return css();
            case 'javascript': return javascript();
            default: return html();
        }
    };

    return (
        <Container style={open ? null : { flexGrow: 0 }}>
            <Header>
                <Heading>
                    <Box
                        component="span"
                        style={{
                            background: color,
                            borderRadius: 5,
                            marginRight: 5,
                            height: 20,
                            width: 20,
                            display: 'flex',
                            placeContent: 'center',
                            color: '#000',
                            paddingBottom: 2,
                        }}
                    >
                        {icon}
                    </Box>
                    {heading}
                </Heading>
                <CloseFullscreen
                    fontSize="small"
                    style={{ alignSelf: 'center' }}
                    onClick={() => setOpen(prev => !prev)}
                />
            </Header>

            <CodeMirror
                value={value}
                height="200px"
                theme={oneDark}
                extensions={[getLanguageExtension(language)]}
                onChange={(val) => onChange(val)}
            />
        </Container>
    );
};

export default Editor;
